import type { HomeSession } from '@databox/ember-integrations/lib/components/Home/addHomeMetricWidgets';
import type { AiTrackingOrigin } from '@databox/types/domains/ai/chat.enums';
import type { MetricSetup } from '@databox/types/domains/metric-setup/metric-setup';

import type { DSSetup, Service } from 'webapp-types';

// Same wire object as MetricSetup bar enum declarations; no spaceAccessId means no source picked.
export function toReactMetricSetup(data: DSSetup.MetricSetupData): MetricSetup | null {
	if (data.spaceAccessId === null || data.spaceAccessId === undefined) {
		return null;
	}

	return {
		...data,
		spaceAccessId: data.spaceAccessId,
		filters: data.filters ?? undefined,
	};
}

// Null until the user is fully logged in; React needs both tokens and both ids to post.
export function buildHomeSession(
	currentUserService: Service.CurrentUser,
	accountService: Service.Account,
	trackingOrigin: AiTrackingOrigin,
): HomeSession | null {
	const { accessToken, userDataToken, numericId } = currentUserService;

	if (!accessToken || !userDataToken || numericId === null) {
		return null;
	}

	return {
		accessToken,
		dataToken: userDataToken,
		spaceId: accountService.id,
		userId: numericId,
		trackingOrigin,
	};
}
